import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { ProductListComponent } from './product-list/product-list.component';
import { CategoryListComponent } from './category-list/category-list.component';
import { OrderListComponent } from './order-list/order-list.component';
import { CreateproductComponent } from './createproduct/createproduct.component';
import { OrderDetailsComponent } from './order-details/order-details.component';


const routes: Routes = [
    {
        path: 'products',
        component: ProductListComponent
    }, 
    {
       path: 'products/:id',
       component: CreateproductComponent
    
    },
    {
        path: 'categories',
        component: CategoryListComponent
    },
    {
        path: 'orders',
        component: OrderListComponent
    },
    {
        path: 'orders/:id',
        component: OrderDetailsComponent
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EcommerceRoutingModule {
}
